import { Component, OnInit,ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatDialogConfig } from '@angular/material'
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { ReportService } from '../.../../../services/report.service';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { CustomDateComponent } from '../.../../customdate/custom-date.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as moment from 'moment';
import { DeviceMasterService } from '../../services/device-master.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { TransformerManagerService } from '../.../../../services/transformerManager.service';
import { DashboardService } from '../.../../../services/dashboard.service';
import { EmsdashboardService } from '../../services/emsdashboard.service';
import * as _ from "lodash";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-emsreport',
  templateUrl: './emsreport.component.html',
  styleUrls: ['./emsreport.component.scss']
})
export class EmsreportComponent implements OnInit {
  
    reportColumns: any;
    report1Columns: any = ["Transformer Id", "Deviceid", "DATE", "Winding_Temperature","Winding_Temp_By_Cal", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level", "R_Ph_N", "Y_Ph_N", "B_Ph_N", "Average_Voltage", "RY_Voltage", "YB_Voltage", "BR_Voltage", "L1", "L2", "L3", "LN", "I1", "I2", "I3", "R1", "R2", "R3", "R_Power_Factor", "Y_Power_Factor", "B_Power_Factor", "Avg_Power_Factor", "R_Active_Power", "Y_Active_Power", "B_Active_Power", "3_Phase_Active_Power", "R_Reactive_Power", "Y_Reactive_Power", "B_Reactive_Power", "3_Phase_Reactive_Power", "R_apparent_Power", "Y_apparent_Power", "B_apparent_Power", "3_Phase_Apparent_Power", "Fequency", "Device_Temperature", "VR_THD", "VY_THD", "VB_THD", "IR_THD", "IY_THD", "IB_THD", "RP_THD", "YP_THD", "BP_THD", "System_kwh", "System_kvArh"];
    // physicalParams: any = ["Transformer Id", "Deviceid", "DATE", "Winding_Temperature", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level"];
    physicalParams: any;
    dataSource;
    typeFilter:any;
    data: any;
    filter: any = {};
    transformerIds: any = [];
    deviceIds:any = [];
    paramFilter: string;
    timeFilter: string;
    idFilter: string;
    timeOptions: any = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
    parametersOption: any = ['All', 'Physical Parameters', "Electrical Parameters"];
    reportData : any = [];
    transformerParam: string;
    electricalParams = [];
    allParameters = [];
    windingtemprature: any[] = [];
    customeSelectedDate:any;
    gradient : Number;
    heading:any =[];
    device;
    meterSerialNumber;
    meterid;
    selectedDevice;
    selectedEnergyMeter;
    meteridforParameters;
    customDateRange;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    constructor(private reportService: ReportService, private matDialog: MatDialog,
        private ngxLoader: NgxUiLoaderService,private EmsdashboardService:EmsdashboardService, private route: ActivatedRoute, private deviceManagerSer: DeviceMasterService,private _dashboardService: DashboardService,private transMngSer: TransformerManagerService) { }

    async ngOnInit() {
      this.ngxLoader.start();
      this.deviceManagerSer.getEMSDeviceId(JSON.parse(localStorage.getItem('userData')).userid).subscribe((response:any) => {
        let Deviceids = []
        response.result.forEach(function (value) {
          Deviceids.push(value.deviceId+"(" +value.sitename+")");
        });
        console.log("what is inside this",Deviceids)
        this.filters('DeviceID',Deviceids[0])
        this.deviceIds = Deviceids;
        this.selectedDevice = Deviceids[0];
      });
      this.ngxLoader.stop();
    }


    async filters(type: string, param: string) {
      param = param.split('(')[0];
       if(type == "DeviceID"){
        this.ngxLoader.startLoader('emsReport');
         this.device = param;
         this.transMngSer.getEnergyMeters(param).toPromise().then((response: any) => {
           let energyMeterId = [];
          response.result.forEach(function (value) {
            energyMeterId.push(value.meterSerialNumber+"(" +value.assetName   +")");
          });
          this.selectedEnergyMeter =  energyMeterId[0];
         // energyMeterId.push("All");
          this.meterSerialNumber = energyMeterId;
          this.meterid = energyMeterId[0].split('(')[0];
          this.meteridforParameters = energyMeterId[0].split('(')[0];
          this.timeFilter = this.timeOptions[0];
          this.transMngSer.getEnergyMeterReportData({"meterid":energyMeterId[0].split('(')[0],"deviceid":this.device,"duration":this.timeOptions[0]}).toPromise().then((response: any) => {
           if(response.result.length>0){
            this.EmsdashboardService.getParameterConfig(energyMeterId[0].split('(')[0]).toPromise().then((response1: any) => {
            if(response1.result.length > 0){
              let Parameters = response1.result[0];
              let parameterList:any = ['Deviceid','DATE','energyMeterId'];
              delete Parameters['deletedFlag'];
              delete Parameters['id'];
              delete Parameters['energyMeterId'];
              let i=0;
              if(i==0){
              for (var key in Parameters){
                if(Parameters[key] == '1'){
                  parameterList.push(key);
                }
                i++;
              }
            }
            this.dataSource = new MatTableDataSource(response.result);
            this.heading =parameterList;
            console.log("kjhfsdksdfsdffdsdf",parameterList)
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            }
            });
            this.ngxLoader.stopLoader('emsReport');
           }  else {
            this.ngxLoader.stopLoader('emsReport');
           }
          });
       });
      }
       if(type == "energyMeter"){
        this.ngxLoader.startLoader('emsReport');
        this.meterid = param;
        let meterid = param;
        if(param == "All"){
          meterid = this.meteridforParameters;
        }
        this.transMngSer.getEnergyMeterReportData({"meterid":param,"duration":this.timeFilter,"deviceid":this.device,"range":this.customDateRange}).toPromise().then((response: any) => {
          if(response.result.length>0){
            this.EmsdashboardService.getParameterConfig(meterid.split('(')[0]).toPromise().then((response1: any) => {
            if(response1.result.length > 0){
              let Parameters = response1.result[0];
              let parameterList:any = ['Deviceid','DATE','energyMeterId'];
              delete Parameters['deletedFlag'];
              delete Parameters['id'];
              delete Parameters['energyMeterId'];
           
              for (var key in Parameters){
                if(Parameters[key] == '1'){
                  parameterList.push(key);
                }
                
              }
            console.log("aksdkjsa",parameterList)
            this.dataSource = new MatTableDataSource(response.result);
           this.heading =parameterList;
           this.dataSource.paginator = this.paginator;
           this.dataSource.sort = this.sort;
   
          } else {
            this.dataSource = []
          }
        });
        this.ngxLoader.stopLoader('emsReport');
      }  else {
       this.ngxLoader.stopLoader('emsReport');
      }
      });
    }
       if(type == "date"){
        this.ngxLoader.startLoader('emsReport');
        this.timeFilter = param;
        let duration;
        if(param == "Today"){
            duration = "Today";
        } else if(param == "Yesterday"){
            duration ="Yesterday";
        } else if( param == "This Week"){
          duration ="This Week"
        } else if( param == "This Month"){
          duration = "This Month";
        } else if( param == "Last Month"){
          duration ="Last Month"
        }
        let meterid = this.meterid;
        if(this.meterid == "All"){
          meterid = this.meteridforParameters;
        }
         if(param == "Custom" ){
          const dialogConfig = new MatDialogConfig();
          let dialogRef = this.matDialog.open(CustomDateComponent, {
              autoFocus: false,
              height: '350px', width: '450px', data: { "details": "", "action": "Add",selectedDate:this.customeSelectedDate}
          });
          dialogRef.afterClosed().subscribe(value => {
            this.customDateRange = value;
              this.transMngSer.getEnergyMeterReportData({"meterid":this.meterid,"duration":param,"range":value,"deviceid":this.device}).toPromise().then((response: any) => {
                if(response.result.length>0){
                  this.EmsdashboardService.getParameterConfig(meterid.split('(')[0]).toPromise().then((response1: any) => {
                    if(response1.result.length > 0){
                      let Parameters = response1.result[0];
                      let parameterList:any = ['Deviceid','DATE','energyMeterId'];
                      delete Parameters['deletedFlag'];
                      delete Parameters['id'];
                      delete Parameters['energyMeterId'];
                      let i=0;
                      if(i==0){
                      for (var key in Parameters){
                        if(Parameters[key] == '1'){
                          parameterList.push(key);
                        }
                        i++;
                      }
                    }
                  this.dataSource = new MatTableDataSource(response.result);
                  this.heading =Object.keys(response.result[0]);
                  this.dataSource.paginator = this.paginator;
                  this.dataSource.sort = this.sort;
                 } else {
                   this.dataSource = []
                 }
              });
              this.ngxLoader.stopLoader('emsReport');
            }  else {
             this.ngxLoader.stopLoader('emsReport');
            }
          });
          });
        } else {
          this.transMngSer.getEnergyMeterReportData({"meterid":this.meterid,"duration":duration,"deviceid":this.device}).toPromise().then((response: any) => {
            if(response.result.length>0){
              this.EmsdashboardService.getParameterConfig(meterid).toPromise().then((response1: any) => {
                if(response1.result.length > 0){
                  let Parameters = response1.result[0];
                  let parameterList:any = ['Deviceid','DATE','energyMeterId'];
                  delete Parameters['deletedFlag'];
                  delete Parameters['id'];
                  delete Parameters['energyMeterId'];
                  let i=0;
                  if(i==0){
                  for (var key in Parameters){
                    if(Parameters[key] == '1'){
                      parameterList.push(key);
                    }
                    i++;
                  }
                }
                this.dataSource = new MatTableDataSource(response.result);
                this.heading =parameterList;
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
               }
               });
              
               this.ngxLoader.stopLoader('emsReport');
             } else {
               this.dataSource = []
               this.ngxLoader.stopLoader('emsReport');
             }
          });
        }
       }
    }

    formatDate(param) {
        return new Promise((resolve, reject) => {
            if (param === 'Today') {
                var d = new Date(),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;
                resolve({ 'date': [year, month, day].join('-'), 'filter': param })
                // return [year, month, day].join('-');
            } else if (param === 'Yesterday') {
                var d = new Date(),
                    month = '' + (d.getMonth() + 1),
                    day = '' + (d.getDate() - 1),
                    year = d.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;
                resolve({ 'date': [year, month, day].join('-'), 'filter': param });
                //return [year, month, day].join('-');
            } else if (param === 'Last Month') {
                resolve({ 'startDate': moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), 'endDate': moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'), 'filter': param })
                // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);
                // resolve({'startDate':[year, month, day].join('-'), 'endDate':[year, month, 30].join('-')});
            }
            else if (param === 'This Month') {
                resolve({ 'startDate': moment().startOf('month').format('YYYY-MM-DD'), 'endDate': moment().endOf('month').format('YYYY-MM-DD'), 'filter': param });
                // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);

            } else if (param === 'This Week') {
                resolve({ 'startDate': moment().startOf('week').format('YYYY-MM-DD'), 'endDate': moment().endOf('week').format('YYYY-MM-DD'), 'filter': param })
                //  resolve('&' + `startDate=${[year, month, startDate].join('-')}` + '&' + `endDate=${[year, month, day].join('-')}` +  '&' + `filter=${param}`);
            }
            else if (param === 'Custom') {
                const dialogConfig = new MatDialogConfig();
                let dialogRef = this.matDialog.open(CustomDateComponent, {
                    autoFocus: false,
                    height: '350px', width: '450px', data: { "details": "", "action": "Add",selectedDate:this.customeSelectedDate}
                });


                dialogRef.afterClosed().subscribe(value => {
                    console.log("Value=======",value);
                    this.customeSelectedDate=value;
                    resolve({ 'startDate': value.startDate, 'endDate': value.endDate, 'filter': param })
                });
            }
        })
    }

    async exportToPdf() {
        try {
            const widths = new Array(this.report1Columns.length).fill('1%'); 
            console.log('WIDTHS:', widths, this.report1Columns);
               this.reportData = await this.formatData(this.data);
               console.log('Report data length:', this.reportData[0].length)
               console.log('Formatted Data:', this.reportData[0]);
               console.log('DATA TO BIND:', this.reportData);
              var docDefinition = {
                  info: {
                      title: 'Transformer Report',
                    },
                  pageOrientation: 'landscape',
                  pageSize: '4A0',
                  content: [
                    {
                      table: {
                        // headers are automatically repeated if the table spans over multiple pages
                        // you can declare how many rows should be treated as headers
                        headerRows: 1,
                       
                       // widths: [ '1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%', '1.5%' ],
                      width: widths,
                       //   body: [
                      //      "serialnumber", "DATE", "Winding_Temperature", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level", "R_Ph_N", "Y_Ph_N", "B_Ph_N", "Average_Voltage", "RY_Voltage", "YB_Voltage", "BR_Voltage", "L1", "L2", "L3", "LN", "I1", "I2", "I3", "R1", "R2", "R3", "R_Power_Factor", "Y_Power_Factor", "B_Power_Factor", "Avg_Power_Factor", "R_Active_Power", "Y_Active_Power", "B_Active_Power", "3_Phase_Active_Power", "R_Reactive_Power", "Y_Reactive_Power", "B_Reactive_Power", "3_Phase_Reactive_Power", "R_apparent_Power", "Y_apparent_Power", "B_apparent_Power", "3_Phase_Apparent_Power", "Fequency", "Energy_Meter_Temprature", "VR_THD", "VY_THD", "VB_THD", "IR_THD", "IY_THD", "IB_THD", "RP_THD", "YP_THD", "BP_THD", "System_kwh", "System_kvArh", "Deviceid", "Parameter1", "Parameter2", "Parameter3", "Parameter4", "Parameter5", "Parameter6", "Parameter7", "Parameter8", "Parameter9", "Parameter10" ],
                      //     [ "serialnumber", "DATE", "Winding_Temperature", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level", "R_Ph_N", "Y_Ph_N", "B_Ph_N", "Average_Voltage", "RY_Voltage", "YB_Voltage", "BR_Voltage", "L1", "L2", "L3", "LN", "I1", "I2", "I3", "R1", "R2", "R3", "R_Power_Factor", "Y_Power_Factor", "B_Power_Factor", "Avg_Power_Factor", "R_Active_Power", "Y_Active_Power", "B_Active_Power", "3_Phase_Active_Power", "R_Reactive_Power", "Y_Reactive_Power", "B_Reactive_Power", "3_Phase_Reactive_Power", "R_apparent_Power", "Y_apparent_Power", "B_apparent_Power", "3_Phase_Apparent_Power", "Fequency", "Energy_Meter_Temprature", "VR_THD", "VY_THD", "VB_THD", "IR_THD", "IY_THD", "IB_THD", "RP_THD", "YP_THD", "BP_THD", "System_kwh", "System_kvArh", "Deviceid", "Parameter1", "Parameter2", "Parameter3", "Parameter4", "Parameter5", "Parameter6", "Parameter7", "Parameter8", "Parameter9", "Parameter10" ],
                      //    // [ { text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Val 4' ]
                      //   ]
                      body: this.reportData,
                      }
                    }
                  ]
                };
              
                 
                  this.ngxLoader.start();
                  pdfMake.createPdf(docDefinition).download();
                  this.ngxLoader.stop();
      
      
        } catch (error) {
          console.log('ERROR:', error);   
        }
      // const widths = [ '1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%', '1.5%','1.5%' ];
     
    }


    formatData(data) {
        return new Promise((resolve,reject) => {
            var dataArr = [];
            var elementCols = Object.keys(data[0]);
            var diffCols = elementCols.filter(x => !this.reportColumns.includes(x))
            dataArr.push(this.reportColumns);
            data.forEach(async element => {
                let rowValues = [];
                this.reportColumns.forEach(col => {
                    rowValues.push(element[col]);
                });
              console.log('RE ARRANGED COLS:', rowValues );
               // delete element['Energy_Meter_Temprature'];
               //  dataArr.push(Object.values(element));
                dataArr.push(rowValues);
            });
             var finalArr = dataArr.filter(x => !Object.keys(x).includes(diffCols.join(",")));
            resolve(dataArr);
        })
    }

    deleteDynamicColumns(element, cols) {
        return new Promise((resolve,reject) => {
            cols.forEach(col => {
              delete element[col];  
            });
            resolve(element);
        })
    }
    fetchReportData(filter) {
        this.ngxLoader.start();
        this.dataSource = null;
        console.log('kasdjasduhaiudbijnijnoaskdoansoddjoasd',filter);
        this._dashboardService.getHvLvDiff(filter).subscribe((response: any) => {
          console.log("Downtime Data",response);
          this.heading =Object.keys(response.data[0]);
          console.log("Heading Data",this.heading);
          this.dataSource = new MatTableDataSource(response.data);
         
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });
        this.ngxLoader.stop();

    }

    generateDataArray(data: any) {
        var reportData: any = [];
        var rowdata: any;
        return new Promise((resolve, reject) => {
            data.forEach(element => {
                rowdata = Object.values(element);
            });

            resolve(rowdata);
        })
    }

    refreshData() {
        this.ngOnInit();
    }

}

